<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/race_series/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">競技種目</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_event_cd_list"
                v-model="sprm.license_event_cd"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">格式</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_event_cd_list"
                v-model="sprm.license_event_cd"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_race_series()"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="w100"
      v-if="
        typeof race_series_list === 'object' &&
        Object.keys(race_series_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%">CD</th>
            <th style="width: 10%">競技種目</th>
            <th style="width: 15%">格式</th>
            <th style="width: auto">名称</th>
            <th style="width: 10%">ソート<br />No</th>
            <th colspan="2" style="width: 12%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in race_series_list" :key="list.id">
            <td>{{ list.race_series_cd }}</td>
            <td>{{ list.license_label }}</td>
            <td>
              {{ list.relations }}
            </td>
            <td>
              {{ list.label }}
            </td>
            <td>{{ list.sort }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'CategoryListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: 'シリーズマスタ一覧',
      fromParentBtn: 'データ登録',
      race_series_obj: [],
      license_event_cd_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      sprm: {
        license_event_cd: '',
        license_class: '',
        license_category: '',
        sales_flg: ''
      },
      sales_flg_list: [
        {
          key: 0,
          label: '販売しない'
        },
        {
          key: 1,
          label: '販売'
        }
      ],
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect
  },
  computed: {
    ...mapState({}),
    get_license_data: function () {
      const cd_list = this.race_series_obj_list
      return function (license_id) {
        // console.log('get_license_data', license_cd , cd_list, cd_list.find(liense => liense.liense_cd == license_cd));
        return cd_list.find(license => license.license_id == license_id)
      }
    },
    get_license_param: function () {
      const get_func = this.get_license_data
      return function (license_cd, param) {
        // console.log('get_license_data get_license_param', license_cd, param);
        // console.log('get_license_data get_license_param get_func', get_func(license_cd));
        const license_data = get_func(license_cd)
        if (
          typeof license_data === 'object' &&
          (typeof license_data[param] === 'string' ||
            typeof license_data[param] === 'number')
        ) {
          return license_data[param]
        }
        return '-'
      }
    },
    get_license_event_data: function () {
      const lists = this.license_event_cd_list
      return function (license_event_cd) {
        return lists.find(cls => cls.id == license_event_cd)
      }
    },
    get_class_data: function () {
      const class_list = this.license_class_list
      return function (class_cd) {
        return class_list.find(cls => cls.key == class_cd)
      }
    },
    get_class_label: function () {
      const get_func = this.get_class_data
      return function (pref_cd) {
        if (get_func(pref_cd)) {
          return get_func(pref_cd).label
        }
        return ''
      }
    },
    get_category_data: function () {
      const category_list = this.license_category_list
      return function (category_cd) {
        return category_list.find(cate => cate.key == category_cd)
      }
    },
    get_category_label: function () {
      const get_func = this.get_category_data
      return function (cateogry_cd) {
        if (get_func(cateogry_cd)) {
          return get_func(cateogry_cd).label
        }
        return ''
      }
    },
    race_series_obj_list: function () {
      const lists = [...this.race_series_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    race_series_list: function () {
      const lists = [...this.race_series_obj]
      return lists
        .map(list => {
          list.license_label = this.get_license_param(
            list.license_id,
            'short_label'
          )
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_event_cd_list: function () {
      const lists = [...this.license_event_cd_obj]
      return lists
        .map(list => {
          list.key = list.id
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    }
  },

  async created() {
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseEventCdList()
    await this.loadRaceSeriesList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'シリーズ一覧です。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.license_cd_obj.find(license_cd => {
          return license_cd.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'license_cd' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadRaceSeriesList()
          })
      }
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'license_cd'
      })
    },
    async search_race_series() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.loadRaceSeriesList()
      } finally {
        this.isLoading = false
      }
    },
    async loadRaceSeriesList() {
      const params = {}
      params['stat'] = [1]
      if (typeof this.sprm === 'object') {
        Object.keys(this.sprm).forEach(param_key => {
          if (this.sprm[param_key]) {
            params[param_key] = this.sprm[param_key]
          }
        })
      }
      console.log('loadRaceSeriesList params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_series_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceSeriesList response', response)
          this.race_series_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.race_series_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/race_series/' + target + '/' })
    }
  }
}
</script>
